import React, { useEffect, useState } from 'react';
import { Divider } from 'primereact/divider';

import './Dashboard.scss';
import { getBitacorasCorrectasIncorectasCont, getCheckListSumaDriversCont, getEficienciaServicio, getModalKmVsRutasCont, getRotacionDeOperadoresCont, getSencibilidadDelClienteCount } from './integracionDashboard';
import { formatearFecha, obtenerFechasUltimos30Dias } from '../../utilidades/formateos';
import Filtros from './components/Filtros';




import Cards from './components/Cards';
const Dashboard = () => {

    const [fechaInicio, setFechaInicio] = useState(obtenerFechasUltimos30Dias().fechaInicio);
    const [fechaFin, setFechaFin] = useState(obtenerFechasUltimos30Dias().fechaFin);
    const [buscar, setBuscar] = useState(false);


    const [dataEficiencia, setDataEficiencia] = useState([])
    const [conteoClientesBCorrectas, setConteoClientesBCorrectas] = useState(0)
    const [conteoKmVsRutas, setConteoKmVsRutas] = useState(0)
    const [nievelSatisfaccion, setNievelSatisfaccion] = useState(0)
    const [conteoSumaDrivers, setConteoSumaDrivers] = useState(0)
    const [conteoRotacion, setConteoRotacion] = useState(0)
    const [params, setParams] = useState(null)
    useEffect(() => {
        const parametros = {
            fecha_inicio: formatearFecha(fechaInicio),
            fecha_fin: formatearFecha(fechaFin)
        }
        getEficienciaServicio(parametros, setDataEficiencia)
        getBitacorasCorrectasIncorectasCont(parametros,setConteoClientesBCorrectas)
        getModalKmVsRutasCont(setConteoKmVsRutas)
        getSencibilidadDelClienteCount(setNievelSatisfaccion)
        getCheckListSumaDriversCont(parametros,setConteoSumaDrivers)
        getRotacionDeOperadoresCont(parametros,setConteoRotacion)
        setParams(parametros)
    }, [buscar])
    return (
        <div className="dashboard-container">
            <Filtros
                setFechaInicio={setFechaInicio}
                fechaInicio={fechaInicio}
                setFechaFin={setFechaFin}
                fechaFin={fechaFin}
                setBuscar={setBuscar}
                buscar={buscar}
            ></Filtros>

            <Divider />
            <Cards
                dataEficiencia={dataEficiencia}
                params={params}
                conteoClientesBCorrectas={conteoClientesBCorrectas}
                conteoKmVsRutas={conteoKmVsRutas}
                nievelSatisfaccion={nievelSatisfaccion}
                conteoSumaDrivers={conteoSumaDrivers}
                conteoRotacion={conteoRotacion}
            ></Cards>
        </div>
    );
};

export default Dashboard;
